import { combineReducers } from 'redux'

import { reducer as logo } from './State/logo'

export default combineReducers({
  logo,
})
